import React  from 'react';
import './AboutMe.css';


const AboutMe = function(props){
  return (
    <div id="about" className="about">

    <div className="space-lg"></div>
    <h2>
    ABOUT ME
  </h2>
  <div className="space-lg"></div>
    <div className="main">
      <div id="main-photo">
        <img alt="Paola L. Valdivia" src="img/pao_f_small.png" />
      </div>
      <div id="main-text">
        <br />
        <span id="myname">Paola L. Valdivia</span>
        <span>Postdoc researcher</span>
        <div id="info">
          <a href="http://www.aviz.fr" target="_blank" rel="noopener noreferrer" >Aviz</a> -
          <a href="http://www.inria.fr" target="_blank" rel="noopener noreferrer" >INRIA</a>
        </div>
    </div>
  </div>

  <div className="space-lg"></div>
    <p className="p-center">
      I obtained my PhD from the <a href="http://www.icmc.usp.br/" target="_blank">Mathematical and Computer Sciences Institute (ICMC) </a>
  of <a href="http://www.saocarlos.usp.br/" target="_blank">University of São Paulo (USP) - São Carlos</a>,
  SP, Brazil, advised by professor <a href= "http://www.icmc.usp.br/~gnonato/" target="_blank">Luis Gustavo Nonato</a>.
     I was visiting researcher at the Aviz Group at INRIA in 2016-2017, and at NYU in 2015 for one month.
  <br />I received my MSc from the <a href="http://www.ucsp.edu.pe/" target="_blank"> University of São Paulo (USP) - São Carlos </a>, SP, Brazil;
  and my BSc from the <a href="http://www.ucsp.edu.pe/" target="_blank">San Pablo Catholic University</a>, Arequipa, Perú.
  </p>
      <p> My research interests are:
        <ul>
          <li> network visualization </li>
          <li> graph signal visualization </li>
          <li> visual analytics </li>
          <li> graph signal processing</li>
        </ul>
      </p>
  <div className="space-lg"></div>
      <p className="links">
        {/*<p className="links"> <a href="http://lattes.cnpq.br/6396583258478990">*/}
        {/*<img alt="Lattes" src="img/lattes.png" className="icon" />  CV Lattes </a>*/}
        <a itemprop="sameAs" content="https://orcid.org/0000-0002-8627-1316" href="https://orcid.org/0000-0002-8627-1316" target="orcid.widget" rel="noopener noreferrer" >
          <img src="https://orcid.org/sites/default/files/images/orcid_24x24.png" alt="ORCID iD icon"  className="icon"/>
          ORCID ID
        </a>
        &nbsp;&nbsp;&nbsp;
<a href="http://br.linkedin.com/in/paolavaldivia"> <img alt="LinkedIn" src="img/linked.png" className="icon" />  LinkedIn </a>
    &nbsp;&nbsp;&nbsp;
<a href="files/cv.pdf"> <img alt="LinkedIn" src="img/pdf.png" className="icon" />  CV </a>
    </p>

    <div className="space-lg"></div>

    </div>
  );
}

export default AboutMe;



// WEBPACK FOOTER //
// ./src/AboutMe.js